import { exportHtml } from "@api/stores/salesInvoices/exportHtml/path";
import { exportPDF } from "@api/stores/salesInvoices/exportPDF/path";
import { installments } from "@api/stores/salesInvoices/installments/path";
import { items } from "@api/stores/salesInvoices/items/path";
import { payments } from "@api/stores/salesInvoices/payments/path";
import { returns } from "@api/stores/salesInvoices/returns/path";
import { stats } from "@api/stores/salesInvoices/stats/path";
import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/sales-invoices/`;
const pathById = `${pathBase}:salesInvoiceId/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;
export type IPathByIdParam = IExtractParams<typeof pathById>;

export const salesInvoices = {
  get: apiPathFunc(pathById),
  getAll: apiPathFunc(pathBase),
  post: apiPathFunc(pathBase),
  delete: apiPathFunc(pathById),
  stats,
  exportPDF,
  items,
  installments,
  payments,
  returns,
  exportHtml,
};
